import Blue from '~/core';

new Blue({
  name: 'Photo Video Grid',
  selector: '.photo-grid',
  setup(grid) {
    const cards = [...grid.querySelectorAll('.photo-grid__card')];
    const more = grid.querySelector('.photo-grid__more');
    const total = cards.length;
    const addCount = 9;
    let visibleCount = total > addCount ? addCount : total;
    let hidden = cards.slice(visibleCount);

		const hideShowMoreBtn = () => {
			if (visibleCount === total) {
				more?.classList?.add("is-hidden");
			}
		};
    
		hideShowMoreBtn();

    const showMore = () => {
      if (visibleCount < total) {
        let added = 0;
        hidden.every((c, i) =>
          i < addCount ? (c.classList.add('is-visible'), true) : false
        );
        if (total - visibleCount > addCount) {
          added = addCount;
        } else {
          added = total - visibleCount;
        }
        hidden = hidden.slice(added);
        visibleCount = visibleCount + added;
      }
			hideShowMoreBtn();
    };

    cards.forEach((c, i) => {
      let contents = c.querySelector('.photo-grid__detail');
      contents
        ?.querySelectorAll('*')
        ?.forEach(i => i.addEventListener('click', e => e.stopPropagation()));
      if (i < addCount) c.classList.add('is-visible');
    });
    
    if (more) {
      this.$addEvents(more, 'click.stop.prevent enter.stop.prevent', showMore);
    }
    

    // const toggleDetail = function () {
    //   if (this.classList.contains('is-active')) {
    //     closeDetail(this);
    //     history.pushState('', document.title, window.location.pathname);
    //   } else {
    //     this.classList.add('is-active');
    //     history.pushState(
    //       '',
    //       document.title,
    //       `${window.location.pathname}#${this.dataset.slug}`
    //     );
    //   }
    // };

    // const closeDetail = card => {
    //   card.classList.remove('is-active');
    //   [...card.querySelectorAll('iframe')].forEach(v =>
    //     v.setAttribute('src', v.src)
    //   );
    // };

    // const checkForMatch = () => {
    //   cards.forEach(closeDetail);
    //   if (window.location.hash) {
    //     let slug = window.location.hash.slice(1);
    //     cards.some(card => {
    //       if (card.dataset.slug === slug) {
    //         card.classList.add('is-active');
    //         history.replaceState(
    //           '',
    //           document.title,
    //           `${window.location.pathname}#${card.dataset.slug}`
    //         );
    //         while (!card.classList.contains('is-visible')) {
    //           console.log('here');
    //           showMore();
    //         }
    //         return true;
    //       } else {
    //         return false;
    //       }
    //     });
    //   }
    // };
    // this.$addEvents(
    //   cards,
    //   'click.stop.prevent enter.stop.prevent',
    //   toggleDetail
    // );

    // window.addEventListener('popstate', checkForMatch);
    // checkForMatch();
  },
});
